import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ComposeNewComponent } from '../compose-new/compose-new.component';
import { MessagesService } from '../messages.service';
import { JwtHelperService } from "@auth0/angular-jwt";
const helper = new JwtHelperService();


@Component({
  selector: 'app-compose-bulk',
  templateUrl: './compose-bulk.component.html',
  styleUrls: ['./compose-bulk.component.scss']
})
export class ComposeBulkComponent  extends FeaturesBaseComponent
implements OnInit
{
composeNewForm: FormGroup;
visible = true;
selectable = true;
removable = true;
addOnBlur = true;
readonly separatorKeysCodes: number[] = [ENTER, COMMA];
recipients: any[] = [];
filteredrecipients: Observable<string[]>;
allSalesReps: any = [];
public messages: any;
filePath: any = null;
@ViewChild("recipientInput") recipientInput: ElementRef<HTMLInputElement>;
@ViewChild("auto") matAutocomplete: MatAutocomplete;
fileToUpload: File;
fileupload: boolean = false;

constructor(
  @Inject(MAT_DIALOG_DATA) public data: any,
  private dialogRef: MatDialogRef<ComposeNewComponent>,
  private messagesService: MessagesService
) {
  super();
  this.messagesService.getAllSalesReps().subscribe(res => {
    if(res['httpcode'] == 200){
      this.allSalesReps = res['data'];
      this.recipients = res['data'];
    }
  })
  this.initForm();
  this.filePath = null;
}

initForm() {
  this.composeNewForm = new FormGroup({
    recipientsControl: new FormControl(""),
    subject: new FormControl("", [Validators.required]),
    message: new FormControl("", [Validators.required]),
  });
}

getUserName(option) {
  return option && option ? option.displayName : ""// || option.role : "";
}

// chips input

add(event: MatChipInputEvent): void {
  const input = event.input;
  const value = event.value;
  // Add our userName
  if ((value || "").trim()) {
    this.recipients.push(value.trim());
  }

  // Reset the input value
  if (input) {
    input.value = "";
  }

  this.composeNewForm.get("recipientsControl").setValue(null);
}

remove(userId): void {
  const index = this.recipients.findIndex((ele) => {
    return ele.userId == userId;
  });
  if (index >= 0) {
    this.recipients.splice(index, 1);
  }
}

selected(event: MatAutocompleteSelectedEvent): void {
  this.recipients.push(event.option.value);
  this.recipientInput.nativeElement.value = "";
  this.composeNewForm.get("recipientsControl").setValue(null);
}

private _filter(value: string): string[] {
  const filterValue = value?.toLowerCase();
  return this.allSalesReps.filter((val) =>
  val.userName.toLowerCase().includes(filterValue)
)
}

onConfirmClick(): void {
  this.dialogRef.close(true);
}
ngOnInit(): void {
  super.ngOnInit();

  this.composeNewForm
    .get("recipientsControl")
    .valueChanges.subscribe((res) => {
      if (res && res) {
        let recipient: string;
        recipient = res.displayName ? res.displayName : res;
        this.filteredrecipients = recipient
          ? this._filter(recipient)
          : this.allSalesReps.slice();
      }
    });
}

ngOnDestroy() {
  super.ngOnDestroy();
}

onComposeNewFormSubmit() {
  console.log(`form valid : ${this.composeNewForm.valid}`);
  if(this.recipients.length <= 0){
    this.toastrService.warning(`Recipients missing`, 'warning', {
      timeOut: 3000,
           
    })
  }
  if (!this.composeNewForm.valid) {
    for (const name in this.composeNewForm.controls) {
      if (this.composeNewForm.controls[name].invalid) {
        console.log("Invalid " + name);
        let _content = name;
        if(name == 'message' ){ _content = "Message Content";}
        if(name == 'subject' ){ _content = "Subject";}
        
        this.toastrService.warning(`${_content} is missing`, 'warning', {
          timeOut: 3000,
               
        })
      } else {
        console.log("Valid " + name);
      }
    }
    return;
  }
  if (this.fileupload == false) {
    this.proceedMessage();
    return;
  }
  const formData: FormData = new FormData();
  if (this.fileToUpload && this.fileToUpload) {
    //alert("Hello")
    formData.append("attachment", this.fileToUpload);
    this.messagesService.attachment(formData).subscribe((res) => {
      if (
        (res.httpcode == 200 &&
          res.responseCodes.find((x) => x == "TILA_101")) ||
        res.responseStatus == "Success"
      ) {
        this.filePath = res.data.filePath;
        this.proceedMessage();
        this.fileToUpload = null;
        return;
      }
    });
  }
}

private proceedMessage() {
  let recipients: any = [];
  this.recipients.forEach((e) => {
    recipients.push(e.userId);
  });
  let _message: any = {};
  _message["subject"] = this.composeNewForm.get("subject").value;
  _message["recipients"] = recipients;
  _message["message"] = this.composeNewForm.get("message").value;
  _message["senderId"] = helper.decodeToken(
    localStorage.getItem("accessToken")
  ).user_id;
  _message["attachment"] = this.filePath;
  _message["importantFlag"] = "No";
  _message["respondMessageId"] = null;
  // socket data push
  //to
  //subject
  this.messagesService.sendMultipleRetailer(_message).subscribe(res => {
    if(res['httpcode'] == 200){
      this.toastrService.success(`Messages sent`, 'success', {timeOut: 3000,})
    }
  })
  this.onConfirmClick();
}

onDiscardMessage() {
  this.composeNewForm.reset();
  this.initForm();
  this.dialogRef.close(true);
}

handleFileInput(files: FileList) {
  this.fileToUpload = files.item(0);
  this.fileupload = true;
}
checkSubmitDisplayed() {
  return !(this.composeNewForm.valid && !this.composeNewForm.pristine); 
}
}
